import { useState } from "react"
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import DashboardLayout from "examples/LayoutContainers/DashboardLayout"
import DashboardNavbar from "examples/Navbars/DashboardNavbar"
import DataTable from "examples/Tables/DataTable"
import Button from "@mui/material/Button"
import Paper from "@mui/material/Paper"
import InputBase from "@mui/material/InputBase"
import CircularProgress from "@mui/material/CircularProgress"
import { ToastContainer, toast } from "react-toastify"
import MDBadge from "components/MDBadge"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import InputLabel from "@mui/material/InputLabel"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
import DownloadIcon from "@mui/icons-material/Download"
import FilterListIcon from "@mui/icons-material/FilterList"
import GetAppIcon from "@mui/icons-material/GetApp"
import Alert from "@mui/material/Alert"
import AlertTitle from "@mui/material/AlertTitle"
import Box from "@mui/material/Box"
import RegistrarVoucherPrintDialog from "./RegistrarVoucherPrintDialog"
import "react-toastify/dist/ReactToastify.css"
const BASE_URL = process.env.REACT_APP_BASE_URL
const BANKS = ["HBL", "UBL", "NBP", "BAL"]

const authHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${sessionStorage.getItem("token")}`,
})

function RegistrarVouchers() {
  const [voucherNumber, setVoucherNumber] = useState("")
  const [loading, setLoading] = useState(false)
  const [vouchers, setVouchers] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedVoucher, setSelectedVoucher] = useState(null)

  const [payModalOpen, setPayModalOpen] = useState(false)
  const [selectedBank, setSelectedBank] = useState("")
  const [transactionId, setTransactionId] = useState("")
  const [paymentDateTime, setPaymentDateTime] = useState("")
  const [payingVoucherCode, setPayingVoucherCode] = useState("")

  const [bulkPayModalOpen, setBulkPayModalOpen] = useState(false)
  const [csvFile, setCsvFile] = useState(null)
  const [csvData, setCsvData] = useState([])
  const [csvErrors, setCsvErrors] = useState([])
  const [bulkPayLoading, setBulkPayLoading] = useState(false)
  const [successVouchers, setSuccessVouchers] = useState([])
  const [errorVouchers, setErrorVouchers] = useState([])
  const [registrarVoucher, setRegistrarVoucher] = useState(null)
  const [printDialogOpen, setPrintDialogOpen] = useState(false)

  const [filterModalOpen, setFilterModalOpen] = useState(false)
  const [filterFromDate, setFilterFromDate] = useState("")
  const [filterToDate, setFilterToDate] = useState("")
  const [filterBank, setFilterBank] = useState("")
  const [filterLoading, setFilterLoading] = useState(false)
  const [filterNotPushedModalOpen, setFilterNotPushedModalOpen] = useState(false)
  const [filterNotPushedFromDate, setFilterNotPushedFromDate] = useState("")
  const [filterNotPushedToDate, setFilterNotPushedToDate] = useState("")
  const [filterNotPushedBank, setFilterNotPushedBank] = useState("")
  const [filterNotPushedLoading, setFilterNotPushedLoading] = useState(false)

  const [bulkSearchModalOpen, setBulkSearchModalOpen] = useState(false)
  const [bulkSearchInput, setBulkSearchInput] = useState("")
  const [bulkSearchLoading, setBulkSearchLoading] = useState(false)

  const openRegistrarPrintDialog = async (code) => {
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_registrar_voucher_for_print/${code}`, {
        method: "GET",
        headers: authHeaders(),
      })
      const data = await response.json()
      if (!response.ok) {
        toast.error(data.error || "Error loading voucher for print")
        return
      }
      setRegistrarVoucher(data.registrar_voucher)
      setPrintDialogOpen(true)
    } catch (error) {
      console.error("Error loading registrar voucher for print:", error)
      toast.error("Error loading voucher for print")
    }
  }

  const parseVoucherCodes = (rawText) => {
    if (!rawText) return []
    const tokens = rawText
      .split(/[\s,\t;\r\n]+/)
      .map((t) => t.trim().replace(/^"|"$/g, ""))
      .filter(Boolean)
      .filter((t) => !["voucher_code", "voucher", "code"].includes(t.toLowerCase()))
    return [...new Set(tokens)]
  }

  const handleBulkVoucherSearch = async () => {
    const voucherCodes = parseVoucherCodes(bulkSearchInput)
    if (voucherCodes.length === 0) {
      toast.error("Please paste voucher codes")
      return
    }
    setBulkSearchLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_registrar_vouchers_by_codes`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ voucher_codes: voucherCodes }),
      })
      const data = await response.json()
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers)
        if (Array.isArray(data.not_found_codes) && data.not_found_codes.length > 0) {
          toast.warning(`Found ${data.vouchers.length} vouchers. Not found: ${data.not_found_codes.length}`)
        } else {
          toast.success(`Found ${data.vouchers.length} vouchers`)
        }
        setBulkSearchModalOpen(false)
      } else {
        setVouchers([])
        toast.error(data.error || "No vouchers found")
      }
    } catch (error) {
      toast.error("Error searching vouchers")
    } finally {
      setBulkSearchLoading(false)
    }
  }

  const fetchVoucher = async () => {
    if (!voucherNumber) {
      toast.error("Please enter a voucher number")
      return
    }
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_registrar_voucher_by_code/${voucherNumber}`, {
        method: "GET",
        headers: authHeaders(),
      })
      const data = await response.json()
      if (response.ok && data.vouchers) {
        setVouchers(data.vouchers)
        toast.success("Voucher fetched successfully")
      } else {
        setVouchers([])
        toast.error(data.error || "Voucher not found")
      }
    } catch (error) {
      toast.error("Error fetching voucher")
    } finally {
      setLoading(false)
    }
  }

  const getManualPaidVouchers = async () => {
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_registrar_manual_paid_vouchers`, {
        method: "GET",
        headers: authHeaders(),
      })
      const data = await response.json()
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers)
        toast.success("Manual paid vouchers fetched successfully")
      } else {
        setVouchers([])
        toast.error(data.error || "No manual paid vouchers found")
      }
    } catch (error) {
      toast.error("Error fetching manual paid vouchers")
    } finally {
      setLoading(false)
    }
  }

  const handleFilterPaidVouchers = async () => {
    if (!filterFromDate || !filterToDate) {
      toast.error("Please select date range")
      return
    }
    setFilterLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/filter_paid_registrar_vouchers`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          from_date: filterFromDate,
          to_date: filterToDate,
          bank: filterBank,
        }),
      })
      const data = await response.json()
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers)
        toast.success(`Found ${data.vouchers.length} filtered vouchers`)
        setFilterModalOpen(false)
      } else {
        setVouchers([])
        toast.error(data.error || "No vouchers found for the given criteria")
      }
    } catch (error) {
      toast.error("Error filtering vouchers")
    } finally {
      setFilterLoading(false)
    }
  }

  const fetchNotPushedVouchers = async () => {
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/get_registrar_vouchers_not_pushed_to_sap`, {
        method: "GET",
        headers: authHeaders(),
      })
      const data = await response.json()
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers)
        toast.success("Vouchers fetched successfully")
      } else {
        setVouchers([])
        toast.error(data.error || "No vouchers found")
      }
    } catch (error) {
      toast.error("Error fetching vouchers")
    } finally {
      setLoading(false)
    }
  }

  const filterPaidNotPushedVouchers = async () => {
    if (!filterNotPushedFromDate || !filterNotPushedToDate) {
      toast.error("Please select date range")
      return
    }
    setFilterNotPushedLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/filter_paid_not_pushed_registrar_vouchers`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          from_date: filterNotPushedFromDate,
          to_date: filterNotPushedToDate,
          bank: filterNotPushedBank,
        }),
      })
      const data = await response.json()
      if (response.ok && Array.isArray(data.vouchers)) {
        setVouchers(data.vouchers)
        toast.success(`Found ${data.vouchers.length} filtered vouchers not pushed to SAP`)
        setFilterNotPushedModalOpen(false)
      } else {
        setVouchers([])
        toast.error(data.error || "No vouchers found for the selected criteria")
      }
    } catch (error) {
      toast.error("Error filtering vouchers")
    } finally {
      setFilterNotPushedLoading(false)
    }
  }

  const handlePushToSAP = async (voucher_code) => {
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/push_registrar_voucher_to_sap`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ voucher_code }),
      })
      const data = await response.json()
      if (response.ok) {
        toast.success("Voucher pushed to SAP successfully")
        setVouchers((prev) =>
          prev.map((v) =>
            v.voucher_code === voucher_code ? { ...v, is_added_to_sap: 1, sap_response: data.response } : v,
          ),
        )
      } else {
        toast.error(data.error || "Error pushing voucher to SAP")
      }
    } catch (error) {
      toast.error("Error pushing voucher to SAP")
    } finally {
      setLoading(false)
    }
  }

  const handleBulkPushToSap = async () => {
    if (!vouchers || vouchers.length === 0) {
      toast.error("No vouchers to push")
      return
    }
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/bulk_push_to_sap_registrar_vouchers`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ voucher_codes: vouchers.map((v) => v.voucher_code) }),
      })
      const data = await response.json()
      if (response.ok) {
        toast.success("Bulk push to SAP started in the background")
      } else {
        toast.error(data.error || "Error in bulk push to SAP")
      }
    } catch (error) {
      toast.error("Error in bulk push to SAP")
    } finally {
      setLoading(false)
    }
  }

  const handleExportVouchers = () => {
    if (!vouchers || vouchers.length === 0) {
      toast.error("No vouchers to export")
      return
    }
    try {
      const headers = [
        "Voucher Code",
        "Is Paid",
        "Due Date",
        "Amount",
        "Transaction ID",
        "Payment Date",
        "Student ID",
        "Student Name",
        "Student Phone",
        "Student CNIC",
        "SAP Status",
      ]
      const csvRows = vouchers.map((voucher) => [
        voucher.voucher_code || "",
        voucher.is_paid === 1 ? "Paid" : "Not Paid",
        voucher.due_date
          ? new Date(voucher.due_date).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "long",
              year: "numeric",
              timeZone: "Asia/Karachi",
            })
          : "",
        voucher.amount || "",
        voucher.transaction_id || "",
        voucher.payment_date || "",
        voucher.student_id || "",
        voucher.user_name || "",
        voucher.phone || "",
        voucher.cnic || "",
        voucher.is_added_to_sap === 1 ? "Pushed" : "Not Pushed",
      ])
      const csvContent = [
        headers.join(","),
        ...csvRows.map((row) =>
          row
            .map((field) =>
              typeof field === "string" && (field.includes(",") || field.includes('"') || field.includes("\n"))
                ? `"${field.replace(/"/g, '""')}"`
                : field,
            )
            .join(","),
        ),
      ].join("\n")
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
      const link = document.createElement("a")
      link.setAttribute("href", URL.createObjectURL(blob))
      link.setAttribute("download", `registrar_vouchers_export_${new Date().toISOString().split("T")[0]}.csv`)
      link.style.visibility = "hidden"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      toast.success(`Successfully exported ${vouchers.length} vouchers`)
    } catch (error) {
      console.error("Export error:", error)
      toast.error("Error exporting vouchers")
    }
  }

  const handleView = (voucher_code) => {
    const voucher = vouchers.find((v) => v.voucher_code === voucher_code)
    if (voucher) {
      setSelectedVoucher(voucher)
      setModalOpen(true)
    } else {
      toast.error("Voucher not found")
    }
  }

  const handleViewAttachment = (attachmentUrl) => {
    if (!attachmentUrl) {
      toast.error("Attachment not available")
      return
    }
    window.open(attachmentUrl, "_blank", "noopener,noreferrer")
  }

  const handleUnpayVoucher = async (voucher_code) => {
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/unpay_registrar_voucher`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ voucher_id: voucher_code }),
      })
      const data = await response.json()
      if (response.ok) {
        toast.success("Voucher unpaid successfully")
        setVouchers((prev) => prev.map((v) => (v.voucher_code === voucher_code ? { ...v, is_paid: 0 } : v)))
      } else {
        toast.error(data.error || "Error unpaying voucher")
      }
    } catch (error) {
      toast.error("Error unpaying voucher")
    } finally {
      setLoading(false)
    }
  }

  const handleExtendDate = async (voucher_code) => {
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/extend_registrar_voucher_date`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ voucher_id: voucher_code }),
      })
      const data = await response.json()
      if (response.ok) {
        toast.success("Voucher date extended successfully")
        setVouchers((prev) =>
          prev.map((v) => (v.voucher_code === voucher_code ? { ...v, due_date: data.new_due_date || v.due_date } : v)),
        )
      } else {
        toast.error(data.error || "Error in extend voucher date")
      }
    } catch (error) {
      toast.error("Error in extend voucher date")
    } finally {
      setLoading(false)
    }
  }

  const handlePayVoucherClick = (voucher_code) => {
    setPayingVoucherCode(voucher_code)
    setSelectedBank("")
    setTransactionId("")
    setPaymentDateTime("")
    setPayModalOpen(true)
  }

  const handlePayVoucher = async () => {
    if (!selectedBank || !transactionId || !paymentDateTime) {
      toast.error("Please fill all required fields")
      return
    }
    setLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/pay_registrar_voucher`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({
          voucher_id: payingVoucherCode,
          bank: selectedBank,
          transaction_id: transactionId,
          payment_date: paymentDateTime,
        }),
      })
      const data = await response.json()
      if (response.ok) {
        toast.success("Voucher paid successfully")
        setVouchers((prev) =>
          prev.map((v) =>
            v.voucher_code === payingVoucherCode
              ? {
                  ...v,
                  is_paid: 1,
                  payment_mode: "Manual",
                  transaction_id: `${selectedBank}-${transactionId}`,
                  payment_date: paymentDateTime,
                }
              : v,
          ),
        )
        setPayModalOpen(false)
      } else {
        toast.error(data.error || "Error paying voucher")
      }
    } catch (error) {
      toast.error("Error paying voucher")
    } finally {
      setLoading(false)
    }
  }

  const downloadTemplate = () => {
    const csvContent =
      "voucher_code,bank,transaction_id,payment_date,amount\nVOUCHER001,HBL,TXN123456789,2024-01-15T10:30:00,5000\nVOUCHER002,UBL,TXN987654321,2024-01-15T11:45:00,7500"
    const blob = new Blob([csvContent], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "registrar_bulk_payment_template.csv"
    a.click()
    window.URL.revokeObjectURL(url)
  }

  const parseCsvFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (e) => {
        try {
          const text = e.target.result
          const lines = text.split("\n").filter((line) => line.trim())
          const headers = lines[0].split(",").map((h) => h.trim())
          const requiredHeaders = ["voucher_code", "bank", "transaction_id", "payment_date", "amount"]
          const missingHeaders = requiredHeaders.filter((h) => !headers.includes(h))
          if (missingHeaders.length > 0) {
            reject(`Missing required columns: ${missingHeaders.join(", ")}`)
            return
          }
          const data = []
          const errors = []
          for (let i = 1; i < lines.length; i++) {
            const values = lines[i].split(",").map((v) => v.trim())
            const row = {}
            headers.forEach((header, index) => {
              row[header] = values[index] || ""
            })
            const rowErrors = []
            if (!row.voucher_code) rowErrors.push("Voucher code is required")
            if (!row.bank) rowErrors.push("Bank is required")
            if (!BANKS.includes(row.bank)) rowErrors.push(`Bank must be one of: ${BANKS.join(", ")}`)
            if (!row.transaction_id) rowErrors.push("Transaction ID is required")
            if (!row.payment_date) rowErrors.push("Payment date is required")
            if (!row.amount || isNaN(Number.parseFloat(row.amount))) rowErrors.push("Valid amount is required")
            if (rowErrors.length > 0) {
              errors.push(`Row ${i + 1}: ${rowErrors.join(", ")}`)
            } else {
              data.push({
                voucher_id: row.voucher_code,
                bank: row.bank,
                transaction_id: row.transaction_id,
                payment_date: row.payment_date,
                amount: Number.parseFloat(row.amount),
              })
            }
          }
          resolve({ data, errors })
        } catch (error) {
          reject("Error parsing CSV file")
        }
      }
      reader.readAsText(file)
    })
  }

  const handleCsvUpload = async (event) => {
    const file = event.target.files[0]
    if (!file) return
    if (file.type !== "text/csv" && !file.name.endsWith(".csv")) {
      toast.error("Please upload a CSV file")
      return
    }
    setCsvFile(file)
    setBulkPayLoading(true)
    try {
      const { data, errors } = await parseCsvFile(file)
      setCsvData(data)
      setCsvErrors(errors)
      if (errors.length > 0) {
        toast.warning(`CSV uploaded with ${errors.length} errors. Please review before proceeding.`)
      } else {
        toast.success(`CSV uploaded successfully. ${data.length} records ready for processing.`)
      }
    } catch (error) {
      toast.error(error)
      setCsvData([])
      setCsvErrors([])
    } finally {
      setBulkPayLoading(false)
    }
  }

  const handleBulkPay = async () => {
    if (csvData.length === 0) {
      toast.error("No valid data to process")
      return
    }
    if (csvErrors.length > 0) {
      toast.error("Please fix all errors before proceeding")
      return
    }
    setBulkPayLoading(true)
    try {
      const response = await fetch(`${BASE_URL}/fee_voucher/bulk_pay_registrar_vouchers`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ payments: csvData }),
      })
      const data = await response.json()
      if (response.ok) {
        toast.success(`Bulk payment processed. ${data.success?.length || 0} vouchers paid.`)
        setCsvFile(null)
        setCsvData([])
        setCsvErrors([])
        setSuccessVouchers(data.success || [])
        setErrorVouchers(data.errors || [])
      } else {
        toast.error(data.error || "Error processing bulk payment")
      }
    } catch (error) {
      toast.error("Error processing bulk payment")
    } finally {
      setBulkPayLoading(false)
    }
  }

  const resetBulkPayModal = () => {
    setBulkPayModalOpen(false)
    setCsvFile(null)
    setCsvData([])
    setCsvErrors([])
    setSuccessVouchers([])
    setErrorVouchers([])
  }

  const columns = [
    { Header: "Voucher Code", accessor: "voucher_code", align: "center" },
    {
      Header: "Is Paid",
      accessor: "is_paid",
      align: "center",
      Cell: ({ value }) => (
        <MDBadge
          badgeContent={value === 1 ? "Paid" : "Not Paid"}
          color={value === 1 ? "success" : "warning"}
          variant="gradient"
          size="sm"
        />
      ),
    },
    { Header: "Due Date", accessor: "due_date", align: "center" },
    { Header: "Amount", accessor: "amount", align: "center" },
    { Header: "Transaction ID", accessor: "transaction_id", align: "center" },
    { Header: "Payment Date", accessor: "payment_date", align: "center" },
    { Header: "Payment Mode", accessor: "payment_mode", align: "center" },
    { Header: "Student ID", accessor: "student_id", align: "center" },
    { Header: "Student Name", accessor: "name", align: "center" },
    { Header: "Student Phone", accessor: "phone", align: "center" },
    { Header: "Student CNIC", accessor: "cnic", align: "center" },
    { Header: "Manual Paid By", accessor: "manual_paid_by", align: "center" },
    { Header: "Last Performed By", accessor: "last_performed_by", align: "center" },
    {
      Header: "SAP Status",
      accessor: "is_added_to_sap",
      align: "center",
      Cell: ({ value }) => (
        <MDBadge
          badgeContent={value === 1 ? "Pushed" : "Not Pushed"}
          color={value === 1 ? "success" : "error"}
          variant="gradient"
          size="sm"
        />
      ),
    },
    {
      Header: "Actions",
      accessor: "actions",
      align: "center",
      Cell: ({ row }) => (
        <>
          <Button
            variant="contained"
            color="primary"
            size="small"
            disabled={row.original.is_added_to_sap === 1 || row.original.is_paid !== 1 || loading}
            onClick={() => handlePushToSAP(row.original.voucher_code)}
            style={{ minWidth: "80px", fontSize: "0.75rem", color: "white" }}
          >
            Push to SAP
          </Button>
          <Button
            variant="contained"
            color="info"
            size="small"
            onClick={() => handleView(row.original.voucher_code)}
            sx={{ minWidth: "60px", fontSize: "0.75rem" }}
          >
            View
          </Button>
          {row.original.is_paid === 1 ? (
            <Button
              variant="contained"
              color="warning"
              size="small"
              disabled={loading}
              onClick={() => handleUnpayVoucher(row.original.voucher_code)}
              sx={{ minWidth: "60px", fontSize: "0.75rem" }}
            >
              Unpay
            </Button>
          ) : (
            <Button
              variant="contained"
              color="success"
              size="small"
              disabled={loading}
              onClick={() => handlePayVoucherClick(row.original.voucher_code)}
              sx={{ minWidth: "60px", fontSize: "0.75rem" }}
            >
              Pay
            </Button>
          )}
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => handleExtendDate(row.original.voucher_code)}
            sx={{ minWidth: "60px", fontSize: "0.75rem" }}
            style={{ marginTop: "10px", color: "white" }}
          >
            Extend 2 days
          </Button>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => openRegistrarPrintDialog(row.original.voucher_code)}
            sx={{ minWidth: "60px", fontSize: "0.75rem" }}
            style={{ marginTop: "10px", color: "white", marginLeft: "5px" }}
          >
            Print Voucher
          </Button>
          {row.original.has_manual_payment_attachment && (
            <Button
              variant="contained"
              color="info"
              size="small"
              onClick={() => handleViewAttachment(row.original.manual_payment_attachment)}
              sx={{ minWidth: "60px", fontSize: "0.75rem" }}
              style={{ marginTop: "10px", color: "black", marginLeft: "5px" }}
            >
              View Attachment
            </Button>
          )}
        </>
      ),
    },
  ]

  const rows = vouchers.map((v) => ({
    voucher_code: v.voucher_code,
    is_paid: v.is_paid,
    due_date: v.due_date
      ? new Date(v.due_date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
          timeZone: "Asia/Karachi",
        })
      : "",
    amount: v.amount,
    transaction_id: v.transaction_id,
    payment_date: v.payment_date,
    payment_mode: v.payment_mode || "N/A",
    student_id: v.student_id || "N/A",
    name: v.user_name,
    phone: v.phone,
    cnic: v.cnic,
    manual_paid_by: v.manual_paid_by || "N/A",
    last_performed_by: v.last_performed_by_name || "N/A",
    is_added_to_sap: v.is_added_to_sap,
    sap_response: v.sap_response,
    manual_payment_attachment: v.manual_payment_attachment,
    has_manual_payment_attachment: v.has_manual_payment_attachment,
    actions: v,
  }))

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ToastContainer />
      <MDBox pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card className="mb-4">
              <MDBox p={3}>
                <MDTypography variant="h5" fontWeight="medium" mb={2}>
                  Registrar Voucher
                </MDTypography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={2}>
                    <Paper component="form" sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                      <InputBase
                        sx={{ ml: 1, flex: 1, fontSize: "16px" }}
                        placeholder="Voucher Number"
                        inputProps={{ "aria-label": "voucher number" }}
                        value={voucherNumber}
                        onChange={(e) => setVoucherNumber(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault()
                            fetchVoucher()
                          }
                        }}
                      />
                    </Paper>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={fetchVoucher}
                      disabled={loading}
                      style={{ color: "white", width: "100%" }}
                    >
                      {loading ? <CircularProgress size={20} color="inherit" /> : "Fetch Voucher"}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="info"
                      onClick={() => setBulkSearchModalOpen(true)}
                      disabled={loading}
                      style={{ color: "black", width: "100%" }}
                    >
                      Multiple Search
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={getManualPaidVouchers}
                      disabled={loading}
                      style={{ color: "white", width: "100%" }}
                    >
                      {loading ? <CircularProgress size={20} color="inherit" /> : "GET Manual Paid Vouchers"}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setFilterModalOpen(true)}
                      disabled={loading}
                      style={{ color: "white", width: "100%" }}
                      startIcon={<FilterListIcon />}
                    >
                      Filter Paid
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={fetchNotPushedVouchers}
                      disabled={loading}
                      style={{ color: "white", width: "100%" }}
                    >
                      {loading ? <CircularProgress size={20} color="inherit" /> : "Fetch All Not Pushed"}
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="warning"
                      onClick={() => setFilterNotPushedModalOpen(true)}
                      disabled={loading}
                      style={{ color: "black", width: "100%" }}
                      startIcon={<FilterListIcon />}
                    >
                      Filter Paid Not Pushed to SAP
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleBulkPushToSap}
                      disabled={!vouchers || vouchers.length === 0 || loading}
                      style={{ color: "white", width: "100%" }}
                      startIcon={<CloudUploadIcon />}
                    >
                      Push to SAP (Bulk)
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setBulkPayModalOpen(true)}
                      disabled={loading}
                      style={{ color: "white", width: "100%" }}
                      startIcon={<CloudUploadIcon />}
                    >
                      Bulk Pay
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={downloadTemplate}
                      style={{ width: "100%", color: "white" }}
                      startIcon={<DownloadIcon />}
                    >
                      Template
                    </Button>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleExportVouchers}
                      disabled={!vouchers || vouchers.length === 0}
                      style={{ color: "white", width: "100%" }}
                      startIcon={<GetAppIcon />}
                    >
                      Export Vouchers
                    </Button>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
            <Card>
              <MDBox pt={3} pb={3}>
                {loading ? (
                  <MDBox display="flex" justifyContent="center" p={5}>
                    <CircularProgress />
                  </MDBox>
                ) : vouchers && vouchers.length > 0 ? (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                ) : (
                  <MDBox display="flex" flexDirection="column" alignItems="center" p={5}>
                    <MDTypography variant="body1" mt={2}>
                      No vouchers found. Please search or fetch to see results.
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Dialog open={filterModalOpen} onClose={() => setFilterModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Filter Paid Registrar Vouchers</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <TextField
              fullWidth
              margin="normal"
              label="From Date"
              type="date"
              value={filterFromDate}
              onChange={(e) => setFilterFromDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="To Date"
              type="date"
              value={filterToDate}
              onChange={(e) => setFilterToDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Bank (Optional)</InputLabel>
              <Select
                value={filterBank}
                onChange={(e) => setFilterBank(e.target.value)}
                label="Select Bank (Optional)"
                style={{ height: "35px" }}
              >
                <MenuItem value="">
                  <em>All Banks</em>
                </MenuItem>
                {BANKS.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFilterModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleFilterPaidVouchers}
            color="primary"
            variant="contained"
            disabled={filterLoading || !filterFromDate || !filterToDate}
            style={{ color: "white" }}
          >
            {filterLoading ? <CircularProgress size={20} color="inherit" /> : "Filter"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={bulkSearchModalOpen} onClose={() => setBulkSearchModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Search Multiple Registrar Vouchers</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <TextField
              fullWidth
              multiline
              minRows={6}
              label="Paste voucher codes / CSV column"
              value={bulkSearchInput}
              onChange={(e) => setBulkSearchInput(e.target.value)}
              placeholder={"Example:\n100001\n100002\n100003"}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setBulkSearchModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleBulkVoucherSearch}
            color="primary"
            variant="contained"
            disabled={bulkSearchLoading}
            style={{ color: "black" }}
          >
            {bulkSearchLoading ? <CircularProgress size={20} color="inherit" /> : "Search"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={filterNotPushedModalOpen} onClose={() => setFilterNotPushedModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Filter Paid Vouchers Not Pushed to SAP</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <TextField
              fullWidth
              margin="normal"
              label="From Date"
              type="date"
              value={filterNotPushedFromDate}
              onChange={(e) => setFilterNotPushedFromDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="To Date"
              type="date"
              value={filterNotPushedToDate}
              onChange={(e) => setFilterNotPushedToDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Bank (Optional)</InputLabel>
              <Select
                value={filterNotPushedBank}
                onChange={(e) => setFilterNotPushedBank(e.target.value)}
                label="Select Bank (Optional)"
                style={{ height: "35px" }}
              >
                <MenuItem value="">
                  <em>All Banks</em>
                </MenuItem>
                {BANKS.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFilterNotPushedModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={filterPaidNotPushedVouchers}
            color="primary"
            variant="contained"
            disabled={filterNotPushedLoading || !filterNotPushedFromDate || !filterNotPushedToDate}
            style={{ color: "white" }}
          >
            {filterNotPushedLoading ? <CircularProgress size={20} color="inherit" /> : "Filter"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={modalOpen} onClose={() => setModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Registrar Voucher</DialogTitle>
        <DialogContent>
          {selectedVoucher ? (
            <>
              <MDTypography variant="subtitle1" fontWeight="medium" mb={1}>
                Voucher Code: {selectedVoucher.voucher_code}
              </MDTypography>
              <MDTypography variant="body2">Student ID: {selectedVoucher.student_id || "N/A"}</MDTypography>
              <MDTypography variant="body2">Student: {selectedVoucher.user_name || "N/A"}</MDTypography>
              <MDTypography variant="body2">Phone: {selectedVoucher.phone || "N/A"}</MDTypography>
              <MDTypography variant="body2">CNIC: {selectedVoucher.cnic || "N/A"}</MDTypography>
              <MDTypography variant="body2">Amount: {selectedVoucher.amount || "N/A"}</MDTypography>
              <MDTypography variant="body2">Transaction ID: {selectedVoucher.transaction_id || "N/A"}</MDTypography>
              <MDTypography variant="body2">Payment Date: {selectedVoucher.payment_date || "N/A"}</MDTypography>
              <MDTypography variant="body2">Payment Mode: {selectedVoucher.payment_mode || "N/A"}</MDTypography>
              <MDTypography variant="body2" mt={2}>
                <strong>SAP Response:</strong>
              </MDTypography>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  background: "#f9f9f9",
                  padding: "10px",
                  borderRadius: "6px",
                }}
              >
                {selectedVoucher.sap_response
                  ? typeof selectedVoucher.sap_response === "string"
                    ? selectedVoucher.sap_response
                    : JSON.stringify(selectedVoucher.sap_response, null, 2)
                  : "No response available"}
              </pre>
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={payModalOpen} onClose={() => setPayModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Pay Voucher</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Bank</InputLabel>
              <Select
                value={selectedBank}
                onChange={(e) => setSelectedBank(e.target.value)}
                label="Select Bank"
                style={{ height: "35px" }}
              >
                {BANKS.map((bank) => (
                  <MenuItem key={bank} value={bank}>
                    {bank}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              fullWidth
              margin="normal"
              label="Transaction ID"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Payment Date & Time"
              type="datetime-local"
              value={paymentDateTime}
              onChange={(e) => setPaymentDateTime(e.target.value)}
              InputLabelProps={{ shrink: true }}
              required
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPayModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handlePayVoucher}
            color="primary"
            variant="contained"
            disabled={loading || !selectedBank || !transactionId || !paymentDateTime}
            style={{ color: "white" }}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : "Pay"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={bulkPayModalOpen} onClose={resetBulkPayModal} maxWidth="md" fullWidth>
        <DialogTitle>Bulk Payment Upload</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <Alert severity="info" sx={{ mb: 3 }}>
              <AlertTitle>Instructions for Bulk Payment</AlertTitle>
              <MDTypography variant="body2" mb={1}>
                1. Download the CSV template using the Template button
              </MDTypography>
              <MDTypography variant="body2" mb={1}>
                2. Fill in the required columns: voucher_code, bank, transaction_id, payment_date, amount
              </MDTypography>
              <MDTypography variant="body2" mb={1}>
                3. Bank must be one of: {BANKS.join(", ")}
              </MDTypography>
              <MDTypography variant="body2" mb={1}>
                4. Payment date format: YYYY-MM-DDTHH:MM:SS (e.g., 2024-01-15T10:30:00)
              </MDTypography>
              <MDTypography variant="body2">
                5. Only registration-office vouchers are paid. This upload does not push to SAP.
              </MDTypography>
            </Alert>
            <Box sx={{ mb: 3 }}>
              <input
                accept=".csv"
                style={{ display: "none" }}
                id="registrar-csv-upload"
                type="file"
                onChange={handleCsvUpload}
              />
              <label htmlFor="registrar-csv-upload">
                <Button
                  variant="contained"
                  component="span"
                  startIcon={<CloudUploadIcon />}
                  style={{ color: "white" }}
                  fullWidth
                  sx={{ mb: 2, height: "50px" }}
                >
                  {csvFile ? csvFile.name : "Choose CSV File"}
                </Button>
              </label>
            </Box>
            {bulkPayLoading && !csvData.length && !csvErrors.length && (
              <Box display="flex" justifyContent="center" my={2}>
                <CircularProgress />
                <MDTypography variant="body2" ml={2}>
                  Processing CSV file...
                </MDTypography>
              </Box>
            )}
            {csvData.length > 0 && (
              <Alert severity="success" sx={{ mb: 2 }}>
                <AlertTitle>CSV Data Preview</AlertTitle>
                <MDTypography variant="body2">Successfully parsed {csvData.length} records</MDTypography>
              </Alert>
            )}
            {csvErrors.length > 0 && (
              <Alert severity="error" sx={{ mb: 2 }}>
                <AlertTitle>CSV Validation Errors</AlertTitle>
                {csvErrors.map((error, index) => (
                  <MDTypography key={index} variant="body2" sx={{ mb: 0.5 }}>
                    • {error}
                  </MDTypography>
                ))}
              </Alert>
            )}
            {successVouchers.length > 0 && (
              <Alert severity="success" sx={{ mb: 2 }}>
                <AlertTitle>Successful Payments</AlertTitle>
                {successVouchers.map((voucher, index) => (
                  <MDTypography key={index} variant="body2" sx={{ mb: 0.5 }}>
                    • {voucher} - Paid
                  </MDTypography>
                ))}
              </Alert>
            )}
            {errorVouchers.length > 0 && (
              <Alert severity="error" sx={{ mb: 2 }}>
                <AlertTitle>Failed Payments</AlertTitle>
                {errorVouchers.map((voucher, index) => (
                  <MDTypography key={index} variant="body2" sx={{ mb: 0.5 }}>
                    • {voucher.voucher_id} - {voucher.error || "Unknown error"}
                  </MDTypography>
                ))}
              </Alert>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={resetBulkPayModal} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={handleBulkPay}
            color="primary"
            variant="contained"
            disabled={bulkPayLoading || csvData.length === 0 || csvErrors.length > 0}
            style={{ color: "white" }}
          >
            {bulkPayLoading ? <CircularProgress size={20} color="inherit" /> : "Process Bulk Payment"}
          </Button>
        </DialogActions>
      </Dialog>

      <RegistrarVoucherPrintDialog
        open={printDialogOpen}
        onClose={() => setPrintDialogOpen(false)}
        voucher={registrarVoucher}
      />
    </DashboardLayout>
  )
}

export default RegistrarVouchers
